/**
 * Utilitários de segurança no frontend.
 * - Mensagens de erro seguras (nunca expor stack ou dados internos ao usuário).
 * - Logger que não vaza dados sensíveis em produção.
 */

const isDev = process.env.NODE_ENV === 'development';

/** Palavras que indicam conteúdo sensível (não enviar ao usuário). */
const SENSITIVE_KEYS = ['stack', 'config', 'request', 'response', 'userId', 'user_id', 'token', 'password', 'secret', 'authorization'];

function isSensitiveValue(value) {
  if (value == null) return false;
  const str = typeof value === 'string' ? value : JSON.stringify(value);
  const lower = str.toLowerCase();
  return SENSITIVE_KEYS.some(k => lower.includes(k));
}

/**
 * Retorna uma mensagem de erro segura para exibir ao usuário.
 * Nunca expõe stack trace, response.data completo ou detalhes internos.
 */
export function getSafeErrorMessage(error, fallback = 'Ocorreu um erro. Tente novamente.') {
  if (!error) return fallback;
  try {
    const data = error.response?.data;
    if (data && typeof data === 'object' && typeof data.error === 'string' && !isSensitiveValue(data.error)) {
      return data.error;
    }
    if (typeof error.message === 'string' && error.message && !isSensitiveValue(error.message)) {
      return error.message;
    }
  } catch (_) {
    // ignorar
  }
  return fallback;
}

/**
 * Logger seguro: em produção não exibe nenhum log (zero vazamento).
 */
export const safeLog = {
  info: (...args) => { if (isDev) console.log(...args); },
  warn: (...args) => { if (isDev) console.warn(...args); },
  error: (message, err) => { if (isDev) console.error(message, err != null ? err : ''); }
};
